import { each,extend, filter, findWhere, indexOf, has, isArray, isEqual, map, omit, sortBy, groupBy, union, where, without, uniq, isMatch,find } from 'underscore'

import Labels from 'Assets/Labels'
import React from 'react'
import moment from 'moment'
import CryptoJS  from 'crypto-js'
import {Row} from 'react-bootstrap'

import TableData from 'Components/common/TableData'


const styles = {
	msg: {
		icon: { margin: '0 0 4vh 0' },
		iconnm: { margin: '0'}
	}
}

const uuidv4 = require('uuid/v4')

export const infoMessage = (message) => {
	let modalObj = {
		body:
		<div>
			<i style={styles.msg.icon} className="fa fa-envelope fa-3x" />
			<p>{message}</p>
		</div>
	}
	return modalObj
}

export const uniqArray = (list, item) => {
	return uniq(list, item)
}

export const groupedBy = (list, item) => {
	return map(groupBy(list, item), clist => clist.map(i => omit(i, item)))
}

export const isValidEmail = (mail) => {
	return /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(mail)
}

export const isValidEmail2 = (mail) => {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(mail).toLowerCase());
}

export const isValidRFC = (rfc) => {
	return /^([A-ZÑ]{3}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z\d][A-Z\d][A-Z\d]))$/.test(rfc)
}

export const getItems = (list, item) => {
	return where(list, item)
}

export const removeItem = (list, item) => {

	let elements = where(list, item)

	if (elements && elements.length > 0) {

		let listElements = list

		elements.map(item => {
			listElements = without(listElements, item)
		})

		return listElements

	} else {
		return list
	}
}

export const removeItemByPositions = (list, ini, end) => {
	return list.filter((item, index) => {
		if (index < ini || index > end) return item
	});
}

export const cleanPositionInArray = (list, ini, end, key, value) => {
	const newList = list.map(a => Object.assign({}, a));

	return newList.map((item, index) => {
		if (index >= ini && index <= end) { item[key] = value; return item; }
		else return item
	});
}

export const filterItem = (list, item) => {
	return filter(list, function (value) { return value.cp.includes(item.cp) })
}

export const filterItemRemove = (list, item) => {
	return filter(list, function (value) { return value != item })
}

export const unionArray = (list1, list2) => {
	return union(list1, list2)
}

export const getUUID = () => {
	return uuidv4()
}

export const isChange = (object, other) => {
	return isEqual(object, other)
}

export const sortByAttr = (list, attr) => {
	return sortBy(list, attr)
}

export const containsItem = (list, item) => {
	return findWhere(list, item) ? true : false
}

export const getItem = (list, item) => {
	return findWhere(list, item)
}

export const indexOfItem = (list, item) => {
	return indexOf(list, item)
}

export const getListPropsOmit = (list, props) => {
	return map(list, function (o) { if (o.tmp || o.custom || o.id) { return omit(o, props) } else { return o } })
}

export const getListPropsOmitById = (list, id, props) => {
	return map(list, function (o) { if ( has(o, id) ) { return omit(o, props) } else { return o } })
}

export const getObjPropsRemove = (obj, props) => {
	return omit(obj, props)
}

export const replaceObject = (list, item, newItem) => {
	return map(list, (o) => {
		if (isMatch(o, item)) {
			return newItem
		} else {
			return o
		}
	})
}

export const getMessageResponse = (response) => {

	let message = Labels.errorMessage

	if (response.message) {
		message = response.message
	} else if (response.descripcionError) {
		message = response.descripcionError
	} else if (response.errorMessage) {
		message = response.errorMessage
	}

	return message
}

export const questionMessage = (message, okClick, cancelClick) => {
	let modalObj = {
		body: <div>
			<i style={styles.msg.icon} className="fa fa-question-circle fa-3x text-info" />
			<p>{message}</p>
		</div>,
		footer: [
			{
				txt: "SI",
				type: "primary",
				onClick: okClick
			},
			{
				txt: "NO",
				type: "primary",
				onClick: cancelClick
			}
		]
	}

	return modalObj
}

export const warningMessage = (message) => {
	let modalObj = {
		body:
		<div>
			<i style={styles.msg.icon} className="fa fa-exclamation-triangle fa-3x text-warning" />
			<p>{message}</p>
		</div>
	}
	return modalObj
}

export const htmlContentMessage = (content) => {
	let modalObj = {
		body:
		<div>
			<i style={styles.msg.iconnm} className="fa fa-exclamation-triangle fa-3x text-warning" />
			{content}
		</div>
	}
	return modalObj
}

export const showMessage = (message) => {
	let modalObj = {
		closeButton: true,
		body: <div>
			<i style={styles.msg.icon} className="fa fa-check fa-3x text-success" />
			<p>{message}</p>
		</div>
	}

	return modalObj
}

export const docsMessage = (arrayLinks = [], onClickView) => {
	const handlerDocumentById=(row)=>{
		onClickView(row.id)
	}
	if (!arrayLinks)
		arrayLinks = []
	let modalObj = {
		closeButton: true,
		title: "Documentación PLD",
		body: <div>
			<i style={styles.msg.icon} className="fa fa-file fa-3x text-info" />
			<TableData
				columns={[{name: 'Nombre de Documento',id: 'alias', type: 'simple',headerAlign: 'center',dataAlign: 'left' }]}
				data={arrayLinks}
				onClickView={handlerDocumentById}
				view
				/>
		</div>
	}

	return modalObj
}

export const customMessage = (title, body, bsSize, footer) => {
	let modalObj = {
		title: title,
		body: body,
		bsSize: bsSize,
		footer,
	}

	return modalObj
}

export const errorMessage = (message) => {
	let modalObj = {
		body: <div>
			<i style={styles.msg.icon} className="fa fa-times-circle fa-3x text-danger" />
			<p className={message.length > 52 ? "textOverflow" : ""}>{message}</p>
		</div>
	}

	return modalObj
}

export const successMessage = () => {
	let modalObj = {
		body: <div>
			<i style={styles.msg.icon} className="fa fa-check fa-3x text-success" />
			<p>{Labels.successMessage}</p>
		</div>
	}

	return modalObj
}


export const successMessageReport = () => {
  let modalObj = {
    body: <div>
      <i style={styles.msg.icon} className="fa fa-check fa-3x text-success" />
      <p>{Labels.successReport}</p>
    </div>
  }

  return modalObj
}

export const clearNullAndEmpty = (jsonObj) => {

	each(jsonObj, function (value, key) {
		if (value === "" || value === null) {
			delete jsonObj[key]
		} else if (Object.prototype.toString.call(value) === '[object Object]') {
			clearNullAndEmpty(value)
		} else if (isArray(value)) {
			each(value, function (k, v) { clearNullAndEmpty(v) })
		}
	})
}

export const isNullOrEmpty = (jsonObj) => {

	let result = false

	each(jsonObj, function (value) {
		if (value === "" || value === null) {
			result = true
		} else if (Object.prototype.toString.call(value) === '[object Object]') {
			isNullOrEmpty(value)
		} else if (isArray(value)) {
			each(value, function (k, v) { isNullOrEmpty(v) })
		}
	})

	return result
}

export const setDefaultValues = (object) => {

	let jsonObj = Object.assign({}, object)

	each(jsonObj, function (value, key) {
		if (typeof value === "string") {
			jsonObj[key] = ''
		} else if (typeof value === "number") {
			jsonObj[key] = ''
		} else if (typeof value === "boolean") {
			jsonObj[key] = false
		} else if (Object.prototype.toString.call(value) === '[object Object]') {
			clearNullAndEmpty(value)
		} else if (isArray(value)) {
			jsonObj[key] = []
		} else if(value instanceof File){
			jsonObj[key]=null
		}
	})

	return jsonObj
}

export const isBefore = (date1, date2) => {
	return moment(date1).isBefore(date2)
}

export const isAfter = (date1, date2) => {
	return moment(date1).isAfter(date2)
}

export const formatDate = (date, format = 'YYYY-MM-DD') => {
	return moment(date).format(format)
}

export const isEmpty = (prop) => (
  prop === null ||
  prop === undefined ||
  (prop.hasOwnProperty('length') && prop.length === 0) ||
  (prop.constructor === Object && Object.keys(prop).length === 0)
)

export const getSum = (arr = [], attr) => {
	return arr.reduce((a, b) => +a + +parseFloat(b[attr]), 0)
}

export const getToday = (format = 'YYYY-MM-DD' ) => {
	return moment(new Date()).format(format)
}

export const treeSearch = (treeList, attribute, elementSearch) =>  {
	for(let i = 0; i < treeList.length; i++) {
		let result = searchTreeRecursive(treeList[i], attribute, elementSearch);
		if (result ) return result;
	}
}

function searchTreeRecursive(element, attribute, matchingLabel){
	if(element[attribute]  == matchingLabel){
		return element;
	}else if (element.children != null){
		let result = null;
		for(let i=0; result == null && i < element.children.length; i++){
				result = searchTreeRecursive(element.children[i],  attribute, matchingLabel);
		}
		return result;
	}
	return null;
}



export const disabledConfig = (etapa, subEtapa, perfil, esActualizacion) => {
	if (!perfil || perfil === "Donataria" ) perfil = -1

	const ETAPA = {
		REGISTRO: 1,
		INFORMACION: 2,
		SOLICITUD: 3,
	}

	const SUBETAPA = {
		R_DONATARIA: 1,
		R_EJ_RECURSOS: 2,
		R_COMENTARIOS: 3,
		R_ABOGADO: 4,
		R_APROBADO: 5,
		R_RECHAZADO: 6,
		I_EJ_RECURSOS: 7,
		I_INICIO: 1,
		I_DONATARIA: 8,
		I_EJ_INVERSION: 9,
		I_ABOGADO: 10,
		I_APROBADO: 11,
		S_DONATARIA: 1,
		S_EJ_INVERSION: 12,
		S_APROBADO: 13,
		S_RECHAZADO: 14,
		S_SOLICITUD: 37,
		S_COMENTARIOS_REGISTRO: 40,
		S_COMENTARIOS_INFORMACION: 41
	}

	const PERFIL = {
		DONATARIA: -1,
		RECURSOS: 1,
		INVERSION: 2,
		JURIDICO: 3,
		CONTROL: 7
	}
	switch (etapa) {

		case ETAPA.REGISTRO:
			switch (subEtapa) {
				case SUBETAPA.R_DONATARIA:
				case SUBETAPA.R_COMENTARIOS:
					switch (perfil) {
						case PERFIL.DONATARIA:
						return { all: false }
						default:
						return { all: true }
					}
				case SUBETAPA.R_EJ_RECURSOS:
					switch (perfil) {
						case PERFIL.RECURSOS:
							return {
								all: true,
								Documents: { all: false },
								PatronsCouncelors: {
									all: false,
									email: true
								},
								LegalRepresentation: {all: false}
							}
						default:
							return { all: true }
					}
				case SUBETAPA.R_ABOGADO:
					switch (perfil) {
						case PERFIL.JURIDICO:
							return {
								all: true,
								GeneralInfo: {
									all: true,
									constitutionDate: true,
									operationsDate: true,
									jap: true,
									iap: true,
									socialIntervention: true,
									submitButton: true
								},
								PatronsCouncelors: {
									all: true,
									email: true
								},
								Documents: {
									all: true,
								},
								CompanyCharter: {
									all: true,
								},
								LegalRepresentation: {
									all: true,
								}
							}
						default:
						return { "all": true }
					}
				case SUBETAPA.R_APROBADO:
				case SUBETAPA.R_RECHAZADO:
				default:
					return { all: true }
			}
		case ETAPA.INFORMACION:
			switch (subEtapa) {
				case SUBETAPA.I_EJ_INVERSION:
					switch (perfil) {
						case PERFIL.INVERSION:
							return {
								ActivePassiveTable: { all: true },
								AdditionalInfo: {
									all: true,
									theme: false,
									theme1: false,
									theme2: false,
									service: false,
									approach: false,
									addClassification: false,
									classification: false
								},
								Contacts: {
									all: true,
									tableContacts: false,
									submitButton: false
								},
								DocumentsInfo: { all: false },
								Fiscal: { all: true },
								Financial: { all: true },
								IncomeExpensesTable: { all: true },
								Locations: { all: true },
								Objectives: { all: false },
								Population: { all: true }
							}
						default:
							return { all: true }
					}
				case SUBETAPA.I_INICIO:
					return {
						all: false,
						GeneralInfo: {
							all: true
						},
						ContactData: {
							all: true
						},
						PatronsCouncelors: {
							all: true
						},
						Documents: {
							all: true
						},
						CompanyCharter: {
							all: true
						},
						LegalRepresentation: {
							all: true
						}
					}
				case SUBETAPA.I_DONATARIA:
					switch (perfil) {
						case PERFIL.DONATARIA:
							return {
								all: false,
								GeneralInfo: { all: true },
								ContactData: { all: true },
								PatronsCouncelors: { all: true },
								Documents: { all: true },
								CompanyCharter: { all: true },
								LegalRepresentation: { all: true }
							}
						default:
						return { "all": true }
					}
				case SUBETAPA.I_EJ_RECURSOS:{
					switch (perfil) {
						case PERFIL.CONTROL : {
							return {
								GeneralInfo: { all: true },
								ContactData: { all: true },
								PatronsCouncelors: { all: true },
								Documents: { all: true },
								CompanyCharter: { all: true },
								LegalRepresentation: { all: true },
								ActivePassiveTable: { all: false },
								AdditionalInfo: { all: true },
								Contacts: { all: true },
								DocumentsInfo: { all: false },
								Fiscal: { all: true },
								Financial: { all: false },
								IncomeExpensesTable: { all: false },
								Locations: { all: true },
								Objectives: { all: true },
								Population: { all: true },
								tableContacts: { all: true }
							}
						}
						default:
						return {
							GeneralInfo: { all: true },
							ContactData: { all: true },
							PatronsCouncelors: { all: true },
							Documents: { all: true },
							CompanyCharter: { all: true },
							LegalRepresentation: { all: true },
							ActivePassiveTable: { all: true },
							AdditionalInfo: { all: true },
							Contacts: { all: true },
							DocumentsInfo: { all: false },
							Fiscal: { all: true },
							Financial: { all: true },
							IncomeExpensesTable: { all: true },
							Locations: { all: true },
							Objectives: { all: true },
							Population: { all: true },
							tableContacts: { all: true 	}
						}
					}
				}
				case SUBETAPA.I_ABOGADO:
				case SUBETAPA.I_APROBADO:
				default:
					return { all: true }
			}
		case ETAPA.SOLICITUD:
			switch (subEtapa) {
				case SUBETAPA.S_SOLICITUD:

					if (esActualizacion) {
						return {
							DocumentsInfo: { all: false },
							Documents: { all: false },
						}
					} else {
						return { all: false }
					}
				case SUBETAPA.S_COMENTARIOS_REGISTRO:
					return {
						GeneralInfo: { all: false },
						ContactData: { all: false },
						PatronsCouncelors: { all: false },
						Documents: { all: false },
						CompanyCharter: { all: false },
						LegalRepresentation: { all: false },
						ActivePassiveTable: { all: true },
						AdditionalInfo: { all: true },
						Contacts: { all: true },
						DocumentsInfo: { all: true },
						Fiscal: { all: true },
						Financial: { all: true },
						IncomeExpensesTable: { all: true },
						Locations: { all: true },
						Objectives: { all: true },
						Population: { all: true }
					}
				case SUBETAPA.S_COMENTARIOS_INFORMACION:

					if (perfil == "Ejecutivo Inversion") {
						return {
							all: true,
							ActivePassiveTable: { all: true },
							AdditionalInfo: { all: true },
							Contacts: { all: true },
							DocumentsInfo: { all: true },
							Fiscal: { all: true },
							Financial: { all: true },
							IncomeExpensesTable: { all: true },
							Locations: { all: true },
							Objectives: { all: true },
							Population: { all: true }
						}
					} else {
						return {
							all: true,
							ActivePassiveTable: { all: false },
							AdditionalInfo: { all: false },
							Contacts: { all: false },
							DocumentsInfo: { all: false },
							Fiscal: { all: false },
							Financial: { all: false },
							IncomeExpensesTable: { all: false },
							Locations: { all: false },
							Objectives: { all: false },
							Population: { all: false }
						}
					}
				default:
					return { all: true }
			}
		default:
		return { "all": true }
	}
}



export const createTableDonatarias = (data) => {
  return each(data, function(element, index) {
    extend(element,
      {
        name: element.nombreDonataria
      }
    )
  })
}



export const createSelectReportes= (data) => {
  return each(data, function(element, index) {
    extend(element,
      {
        valor: element.nombre,
        tipoReporte: element.id
      }
    )
  })
}

export const createSelectSolutions= (data) => {
	var arr = []
	for (var key in data) {
		arr.push({ id: data[key].corridaId, valor: data[key].nombre })
	}

	return arr
}

export const createSelectDonataria= (data) => {
	var arr = []
	for (var key in data) {
		arr.push({ id: data[key].idDonataria, valor: data[key].donataria })
	}

	return arr
}

export const createSelectYear= (data) => {
	var arr = []
	for (var key in data) {
		arr.push({ id: data[key].id, valor: data[key].anio })
	}

	return arr
}

export const createSelectEvaluacionTipo= (data) => {
	var arr = []
	for (var key in data) {
		arr.push({ id: data[key].id, valor: data[key].estadoEvaluacion })
	}

	return arr
}

export const createSelectEstadoBandera= (data) => {
	var arr = []
	for (var key in data) {
		arr.push({ id: data[key].id, valor: data[key].estado })
	}

	return arr
}

export const createSelectEvaluacionEstado= (data) => {
	var arr = []
	for (var key in data) {
		arr.push({ id: data[key].id, valor: data[key].evaluacion })
	}

	return arr
}

export const seleccionCampos = (data) => {
    let listaSel = []

    data.forEach(function (element){
      if(element.revisado) {

        listaSel.push(element.id)
      }
    })

    return listaSel;
}


export const buscarReporte = (data,id) => {
  let seleccionado

  seleccionado = find(data,function (element) {
    if(element.id === id){
       return element
    }
  })
  return seleccionado;
}



export const listaSeleccionadas = (data) => {
  let total = 0

  data.forEach(function (elemt){
    if(elemt.revisado){
      total+=1
    }
  })
  return total;
}

export const ds_ = (json) => { // Función para desencriptar datos
	json = CryptoJS.AES.decrypt(json, localStorage.n).toString(CryptoJS.enc.Utf8)
	json = JSON.parse(json)

	return json
}

export const ec_ = (json) => { // función para encriptar datos
	json = JSON.stringify(json)
	json = CryptoJS.AES.encrypt(json, localStorage.n).toString()

	return json
}

export const conver_ = (data) => { // Función para desencriptar datos
	const byteCharacters = atob(data);
	const byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
	byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	const byteArray = new Uint8Array(byteNumbers);
	const blob = new Blob([byteArray], { type: 'application/pdf' });
	const blobUrl = URL.createObjectURL(blob);
	window.open(blobUrl, '_blank');

}




// WEBPACK FOOTER //
// ./src/assets/Utils.js